<div class="register-business-header">
  <page-header title="Register Your Business"></page-header
  ><span class="info-icon"
    ><a href="javascript:;"><img src="assets/svg/icons/info.svg"/></a
  ></span>
</div>
<div class="header-text">Thank you for verifying your account. Please complete registration by providing your information.</div>
<div class="register-business">
  <mat-button-toggle-group name="businessType" (change)="selectionChanged($event)" class="button-container" multiple>
    <mat-button-toggle matRipple [value]="CompanyType.SourceSite" class="register-button sourceSite" #businessType1>
      <h2>Source Site</h2>
      <p>Manage excess soil excavation from start to finish in one place</p>
    </mat-button-toggle>
    <mat-button-toggle matRipple [value]="CompanyType.ReceivingSite" class="register-button receivingSite" #businessType2>
      <h2>Receiving Site</h2>
      <p>Ensure compliance with improved visibility of adequate soil placement</p>
    </mat-button-toggle>
    <mat-button-toggle matRipple [value]="CompanyType.QualifiedPerson" class="register-button qualifiedPerson" #businessType3>
      <h2>Qualified Person (QPs)</h2>
      <p>PATH enables affiliated QPs and QP firms to operate more efficiently</p>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="businessType-next {{ businessType1.checked || businessType2.checked || businessType3.checked }}">
  <button class="cmn-blue-btn" mat-raised-button color="primary" (click)="next()">
    Next <span class="material-icons btn-arw">keyboard_arrow_right</span>
  </button>
</div>
